"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feature = void 0;
var Feature;
(function (Feature) {
    Feature[Feature["DURATION"] = 0] = "DURATION";
    Feature[Feature["CONSUMER"] = 1] = "CONSUMER";
    Feature[Feature["MUTED_AUTOPLAY"] = 2] = "MUTED_AUTOPLAY";
    Feature[Feature["BITRATE_SWITCHING"] = 3] = "BITRATE_SWITCHING";
    Feature[Feature["PLAYER_SELECTOR"] = 4] = "PLAYER_SELECTOR";
    Feature[Feature["BROADCAST"] = 5] = "BROADCAST";
})(Feature || (exports.Feature = Feature = {}));
//# sourceMappingURL=feature.js.map